module.exports = __webpack_public_path__ + "static/img/6.0acfe24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/zh/6.png
// module id = Aj32
// module chunks = 0